import React, { Component } from 'react'
import PaymentsPV from './PaymentsPV'
import AuthA from '../../store/actions/AuthA'
import { saveAs } from 'file-saver'

import axios from 'axios'
import sortBy from 'lodash/sortBy'
import find from 'lodash/find'
import {connect} from 'react-redux'

const _ = {
  sortBy: sortBy,
  find: find
}

class PaymentPC extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      searchKey: '',
      fields: ['studentName', 'orNumber', 'orDate', 'type', 'amount', 'file', 'actions'],
      activePage: 1,
      itemPerPage: 10,
      selectedIndex: 0,
      column: null,
      direction: null,
      loaded: false,
      students: [],
      paymentFile: null
    };
  }

  getPayment = () => {
    axios.get(process.env.REACT_APP_URL+'/payments?filter[where][active]=true&filter[include]=student&filter[order]=created%20DESC')
    .then(response => {
      this.setState({ data: response.data, loaded: true });
    });
  }

  getStudents = () => {
    axios.get(process.env.REACT_APP_URL+'/students?filter[where][active]=true')
    .then(response => {
      this.setState({ students: response.data });
    });
  }

  isSearched = (searchKey) => {
    return function(item) {
      return (
        !searchKey ||
        item.orNumber.toLowerCase().includes(searchKey.toLowerCase())
      );
    };
  }

  onSearchChange = (event) => {
    this.setState({ searchKey: event.target.value });
  }

  download = (fileName) => {
    axios({
      url: `${process.env.REACT_APP_URL}/assets/download?module=payments&fileName=${fileName}`,
      method: 'GET',
      responseType: 'blob', // important
    }).then((response) => {
      saveAs(new Blob([response.data]), fileName);
    });
  }

  handleSort = (clickedColumn) => {
    const { column, data, direction } = this.state
    if (column !== clickedColumn) {
      this.setState({
        column: clickedColumn,
        data: _.sortBy(data, [clickedColumn]),
        direction: 'ascending',
      })
      return
    }
    this.setState({
      data: data.reverse(),
      direction: direction === 'ascending' ? 'descending' : 'ascending',
    })
  }

  handlePaginationChange = (e, {activePage}) => {
    this.setState({
      activePage: activePage,
    });
  }

  handleRowClick = (payment) => {
    this.props.history.push(this.props.location.pathname+'/' + payment.paymentId);
  }

  handleSubmit = (data) => {
    const url = process.env.REACT_APP_URL+'/payments';
    axios
      .request({
        method: 'post',
        url: url,
        data: data
      })
      .then(response => {
        alert('Payment succesfully saved!')
        this.getPayment();
        if(this.state.paymentFile !== null) {
          this.handleUploadPaymentFile();
        }
      })
      .catch(err => console.log(err));
  }

  handleUpdate = (data,id) => {
    const url = process.env.REACT_APP_URL+'/payments/'+id;
    axios
      .request({
        method: 'put',
        url: url,
        data: data
      })
      .then(response => {
        alert('Payment succesfully saved!')
        this.getPayment();
        if(this.state.paymentFile !== null) {
          this.handleUploadPaymentFile();
        }
      })
      .catch(err => console.log(err));
  }

  handleDelete = (id) => {
    const url = process.env.REACT_APP_URL+'/payments/'+id;
    axios
      .request({
        method: 'put',
        url: url,
        data: {active: false}
      })
      .then(response => {this.getPayment()})
      .catch(err => console.log(err));
  }

  handleUploadFileChange = (paymentFile) => {
    this.setState({paymentFile});
  }

  handleUploadPaymentFile = () => {
    const url = process.env.REACT_APP_URL+'/assets/upload?module=payments';
    let fileData = new FormData();
    fileData.append('filePath', this.state.paymentFile);
    axios
      .request({
        method: 'post',
        url: url,
        data: fileData
      })
      .then(response => {
        alert(`OR Image was successfully saved.`);
      })
      .catch(error => {
        console.log(error)
        if (error.response) {
          alert(`${error.response.data.error.message}`);
        } else if (error.request) {
          alert(error.request);
        } else {
          // Something happened in setting up the request that triggered an Error
          alert('Error. Please contact your administrator for assistance.');
        }
      });
  }

  componentDidMount() {
    this.props.authFn.getToken()
    this.props.onContentMount({title:'School Setup / Payments'});
    this.getPayment();
    this.getStudents();
  }

  render() {
    return (
      <PaymentsPV
        auth={this.props.auth}
        userType={this.props.userType}
        activePage={this.state.activePage}
        itemPerPage={this.state.itemPerPage}
        column={this.state.column}
        direction={this.state.direction}
        data={this.state.data}
        searchKey={this.state.searchKey}
        fields={this.state.fields}
        loaded={this.state.loaded}
        students={this.state.students}
        paymentFile={this.state.paymentFile}
        isSearched={this.isSearched}
        onSearchChange={this.onSearchChange}
        download={this.download}
        handleSort={this.handleSort}
        handlePaginationChange={this.handlePaginationChange}
        handleRowClick={this.handleRowClick}
        handleSubmit={this.handleSubmit}
        handleUpdate={this.handleUpdate}
        handleDelete={this.handleDelete}
        handleChange={this.handleChange}
        handleUploadFileChange={this.handleUploadFileChange}
      />
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    authFn: AuthA(dispatch)
  }
}

const mapStateToProps = (state) => {
  return {
    auth: state.AuthR.auth,
    userType: state.AuthR.userType
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(PaymentPC);
